import { Discount } from "../../../Utilities";

export function calculateDiscountAmount(
	discount: Pick<Discount, "isPercentageAmount" | "flatAmount" | "percentageAmount">,
	basisPrice: number,
) {
	if (discount.isPercentageAmount) {
		return Math.round(((discount.percentageAmount ?? 0) / 100) * basisPrice);
	}
	return discount.flatAmount;
}
